import api from "./api";

function checkedResponse(response) {
  const meta = response?.data || {};
  if (meta.error || (meta.code != null && Number(meta.code) !== 200)) throw new Error(meta.message || 'Unable to load podcast.');
  return { payload: meta.dataset?.data || {}, meta };
}

export async function fetchPodcastDetail(params = {}) {
  const response = await api.get("/audio-podcast/podcast", { params });
  return checkedResponse(response);
}

export async function storePodcastTime(payload = {}) {
  const response = await api.post("/audio-podcast/store-time", payload);
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function storePodcastProgress(payload = {}) {
  const response = await api.post("/audio-podcast/store-progress", payload);
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function togglePodcastReadStatus(payload = {}) {
  const response = await api.post("/audio-podcast/mark-read", payload);
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function unlockPodcastWithCoins(payload = {}) {
  const response = await api.post("/audio-podcast/unlock-with-coins", payload);
  const result = checkedResponse(response);
  const granted = value => value === true || value === 1 || value === '1';
  if (![result.payload.access_granted, result.payload.accessGranted, result.payload.already_unlocked, result.payload.alreadyUnlocked].some(granted)) {
    throw new Error(result.meta.message || 'Not enough eligible coins to unlock this podcast.');
  }
  return result;
}

export async function rewardPodcastAd(payload = {}) {
  const response = await api.post("/audio-podcast/ad-reward", payload);
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function fetchPodcastViewActivity(params = {}) {
  const response = await api.get("/audio-podcast/view", { params });
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function fetchPodcastPersonalNotes(params = {}) {
  const response = await api.get("/audio-podcast/user-notes", { params });
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function createPodcastPersonalNote(payload = {}) {
  const response = await api.post("/audio-podcast/notes", payload);
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function deletePodcastPersonalNote(payload = {}) {
  const response = await api.delete("/audio-podcast/note-delete", { data: payload });
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function fetchPodcastReports(params = {}) {
  const response = await api.get("/audio-podcast/reports", { params });
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function createPodcastReport(payload = {}) {
  const response = await api.post("/audio-podcast/report", payload);
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function deletePodcastReport(payload = {}) {
  const response = await api.delete("/audio-podcast/report-delete", { data: payload });
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}
